<div class="overflow-x-hidden">
  <site-header hideOnScrollDown class="w-full z-50"></site-header>
  <!-- mon-container class defined in assets/styles/_mon-container.scss -->
  <main class="bg-titan-white mon-container px-4 py-[15px] md:px-[34px] md:py-[30px] xl:px-[50px]">
    <router-outlet></router-outlet>
  </main>
  <site-footer></site-footer>
</div>
